import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import { CarTile } from "@perxis-auto/ui-kit/lib/components/CarTile";
const TileHeader = memo(function TileHeader2({ isLoading = false, ...props }) {
  if (isLoading) {
    return /* @__PURE__ */ jsx(CarTile.TitleSkeleton, {});
  }
  return /* @__PURE__ */ jsx(CarTile.Title, { ...props });
});
export {
  TileHeader
};
